import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidFlashAmount } from '../../../../mechanics/rid-flash-amount/rid-flash-amount';

@Component({
  selector: 'app-flash-amount-page',
  imports: [RidFlashAmount],
  templateUrl: './flash-amount-page.component.html',
})
export class FlashAmountPage {
  protected readonly $router = inject(Router);
  protected readonly numbers = computed(() =>
    Array(5)
      .fill(0)
      .map(() => Math.floor(Math.random() * 30) + 10),
  );
}
